declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    plausible?: (
      event: string,
      options?: { props: Record<string, string> }
    ) => void
  }
}

type Event = "PageView" | "PreviewPlay" | "StreamClick" | "ViewContent"

type Props = {
  provider?: string
  release?: string
}

const pixelStandardEvents: Event[] = ["PageView", "ViewContent"]

export const track = (event: Event, props: Props = {}) => {
  if (typeof window === "undefined") return
  if (typeof window.fbq === "function") {
    const params: Record<string, string> = {}
    if (props.release) params.content_name = props.release
    if (props.provider) params.content_category = props.provider
    window.fbq(
      pixelStandardEvents.includes(event) ? "track" : "trackCustom",
      event,
      params
    )
    if (event === "StreamClick") window.fbq("track", "Lead", params)
  }
  if (
    typeof window.plausible === "function" &&
    !pixelStandardEvents.includes(event)
  ) {
    window.plausible(event, { props: props as Record<string, string> })
  }
}
